// Import WhatsApp SVG icon
import whatsappSvgPath from '../assets/whatsapp.svg';

export function WhatsAppChat() {
  // Hook useLanguage non utilisé actuellement mais pourrait être utile pour l'internationalisation
  const phoneNumber = '+243842613999';
  
  const handleClick = () => {
    const message = encodeURIComponent('Bonjour, je souhaite en savoir plus sur Genius Vente.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-8 right-8 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:bg-[#128C7E] transition-colors duration-200 flex items-center justify-center group z-50"
      aria-label="Chat on WhatsApp"
    >
      <img src={whatsappSvgPath} alt="WhatsApp" className="w-6 h-6 brightness-0 invert" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-xs group-hover:ml-2 transition-all duration-500 ease-in-out">
        WhatsApp
      </span>
    </button>
  );
}
